<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Notificaciones</ion-title>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultHref" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-segment mode="md" [(ngModel)]="show">
      <ion-segment-button mode="md" value="notifications">
        <ion-label>Notificaciones</ion-label>
      </ion-segment-button>
      <ion-segment-button mode="md" value="tickets">
        <ion-label>Tickets</ion-label>
      </ion-segment-button>
    </ion-segment>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="notifications" *ngIf="show=='notifications'">
    <ion-list lines="full" *ngIf="!notifications.length && !loading">
      <ion-item lines="none">
        <ion-label>
          <h2>No tienes notificaciones</h2>
        </ion-label>
      </ion-item>
    </ion-list>
    <ion-list lines="full" *ngIf="!notifications.length && loading">
      <ion-item *ngFor="let notification of [0,1,2,3,4]">
        <ion-skeleton-text animated style="width: 27px; height: 27px" slot="start"></ion-skeleton-text>
        <ion-label>
          <h2>
            <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
          </h2>
          <p class="date">
            <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
          </p>
        </ion-label>
      </ion-item>
    </ion-list>
    <ion-list lines="full">
      <ion-item-sliding *ngFor="let notification of notifications">
        <ion-item (click)="goNotification(notification)">
          <ion-avatar slot="start" *ngIf="notification.image">
            <ion-img [src]="notification.image"></ion-img>
          </ion-avatar>
          <ion-icon
            slot="start"
            *ngIf="!notification.image"
            src="/assets/icon/notification-bell.svg"
            color="primary"
          ></ion-icon>
          <ion-label>
            <h2 [innerHTML]="notification.body"></h2>
            <p>{{notification.created_at | timeAgo : true}}</p>
          </ion-label>
          <ion-icon name="ellipse" slot="end" color="primary" *ngIf="!notification.read_at"></ion-icon>
        </ion-item>
        <ion-item-options side="end">
          <ion-item-option color="danger" (click)="deleteNotification(notification)">
            <ion-icon slot="icon-only" name="trash"></ion-icon>
          </ion-item-option>
        </ion-item-options>
      </ion-item-sliding>
    </ion-list>
  </div>
  <div class="tickets" *ngIf="show=='tickets'">
    <ion-list lines="full" *ngIf="!tickets.length && !loading">
      <ion-item lines="none">
        <ion-label>
          <h2>No tienes tickets</h2>
        </ion-label>
      </ion-item>
    </ion-list>
    <ion-list lines="full" *ngIf="!tickets.length && loading">
      <ion-item *ngFor="let notification of [0,1,2,3,4]">
        <ion-skeleton-text animated style="width: 27px; height: 27px" slot="start"></ion-skeleton-text>
        <ion-label>
          <h2>
            <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
          </h2>
          <p class="date">
            <ion-skeleton-text animated style="width: 40%"></ion-skeleton-text>
          </p>
        </ion-label>
      </ion-item>
    </ion-list>
    <ion-list lines="full">
      <ion-item *ngFor="let ticket of tickets" (click)="goTicket(ticket)">
        <ion-icon slot="start" src="/assets/icon/notification-bell.svg" color="primary"></ion-icon>
        <ion-label>
          <h2>{{ticket.type | ticketType}}</h2>
          <h3>Ticket #{{ticket.id}}</h3>
          <p>{{ticket.created_at | timeAgo : true}}</p>
          <p>{{ticket.status == 0 ? 'Pendiente' : 'Atendido'}}</p>
        </ion-label>
      </ion-item>
    </ion-list>
  </div>
</ion-content>
